<template>
    <div class="w3-col w3-left-align">
    <ContentHeader v-bind:title="$t('no-show-amount-report')" />
  </div>
  <ReportItem
    :columns="pdfColumns"
    :objects="tableData"
    :file-name="$t('no-show-amount-report_')"
    :start-day="$helper.lastMonth()"
    :end-day="$helper.today()"
    @emittedDays="onDateUpdate"
  >
    <StandardTable
      :sort-options="true"
      :no-content="'noData'"
      :column-definitions="columnDefinitions"
      :records="noShowAmountAsList"
    />
  </ReportItem>
</template>

<script>
import StandardTable from "../../common/StandardTable.vue";
import ReportItem from "./ReportItem.vue";
import ContentHeader from "../../common/ContentHeader.vue";

export default {
  name: "AmountOfNoShows",
  components: { StandardTable, ReportItem, ContentHeader },
  mounted() {
    const days = [this.$helper.lastMonth(), this.$helper.today()];
    this.onDateUpdate(days);
  },
  computed: {
    noShowAmountAsList() {
        return this.tableData.map(a => ({
            nrOfNoShows: a.nrOfNoShows,
            site: a.site,
            service: a.service
        }));
    }
  },
  data() {
    return {
      columnDefinitions: [
        {key: "service", label: this.$t("service"), dataKey: "service" },
        {key: "site", label: this.$t("site"), dataKey: "site" },
        { key: "amount_of_no_shows", label: this.$t("amount_of_no_shows"), dataKey: "nrOfNoShows" }
      ],
      tableData: [],
      pdfColumns: [
        { title: this.$t("service"), dataKey: "service" },
        { title: this.$t("site"), dataKey: "site" },
        { title: this.$t("amount_of_no_shows"), dataKey: "nrOfNoShows" }
      ]
    };
  },
  methods: {
    onDateUpdate(days) {
      const queryString = `startDate=${this.$helper.flipDateFormat(days[0])}&endDate=${this.$helper.flipDateFormat(days[1])}`;
      this.fetchNoShowAmountReport(queryString);
    },
    fetchNoShowAmountReport(queryString) {
      this.$restClient.reports
        .amountOfNoShows({query: queryString})
        .then(response => {
          this.tableData = response.data;
        })
        .catch(err => {
          console.log(err);
          this.$notify.notifyError({
            title: this.$t("failed")
          });
        });
    }
  }
};
</script>
